import React from "react";
import styles from "../../styles/PlaywrightTemplate.module.css";


const PlaywrightTemplate = ({ title, sections }) => {
  return (
    <div className={styles.container}>
      <h1 className={styles.pageTitle}>{title}</h1>

      {sections.map((section, index) => (
        <div key={index} className={styles.sectionCard}>
          <h2 className={styles.heading}>{section.heading}</h2>

          <div className={styles.splitLayout}>
            
            {/* LEFT SIDE - UI (40%) */}
            <div className={styles.uiBox}>
              {section.ui}
            </div>

            {/* RIGHT SIDE - CODE (60%) */}
            <div className={styles.codeBox}>
              <pre>
                <code>{section.code}</code>
              </pre>
            </div>

          </div>
        </div>
      ))}
    </div>
  );
};

export default PlaywrightTemplate;